(() => {
  'use strict';
  if (window.ihCollectionShopping) return;
  window.ihCollectionShopping = true;
  const normalize = value => String(value || '').toLowerCase().replace(/\bpair\b/g, '').trim().replace(/\s+/g, ' ');
  const read = node => { try { return JSON.parse(node?.textContent || 'null'); } catch (_) { return null; } };
  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text != null) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const root = () => window.Shopify?.routes?.root || '/';
  const instances = new Map();
  class ShoppingList {
    constructor(element) {
      this.element = element;
      this.data = read(element.querySelector('[data-collection-data]'));
      if (!this.data?.products?.length) return;
      this.form = element.querySelector('form');
      this.rows = [];
      this.message = element.querySelector('[data-shopping-message]');
      this.button = element.querySelector('[data-shopping-submit]');
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); });
      element.querySelector('[data-shopping-fallback]').hidden = true;
      this.form.hidden = false;
      this.update();
      this.expiryTimer = window.setInterval(() => {
        if (!element.isConnected) window.clearInterval(this.expiryTimer);
        else this.totals();
      }, 60000);
    }
    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.data.currency, currencyDisplay:'code'}).format(cents / 100);
    }
    current(variant) {
      const names = read(document.querySelector('[data-guidance-option-names]')) || [];
      const selected = variant || read(document.querySelector('product-info variant-selects [data-selected-variant]'));
      return {finish:selected?.options?.[names.findIndex(name => /finish/i.test(name))] || '', selected};
    }
    update(variant) {
      if (this.busy) return;
      const {finish, selected} = this.current(variant);
      if (finish === this.finish && this.rows.length) return;
      const hadQuantities = this.rows.some(row => Number(row.quantity?.value) > 0);
      this.finish = finish;
      this.rows = [];
      this.element.querySelector('[data-shopping-rows]').replaceChildren();
      this.element.querySelector('[data-shopping-finish]').textContent = finish ? `Matching finish: ${finish}` : 'Choose a finish above to see matching pieces.';
      this.data.products.forEach((product, index) => this.renderRow(product, index, selected));
      this.message.textContent = hadQuantities ? 'The finish changed. Quantities were cleared so you can review your new selections.' : '';
      this.totals();
      document.dispatchEvent(new CustomEvent('product-info:loaded'));
    }
    renderRow(product, index, selected) {
      const matches = product.variants.filter(v => this.finish && product.finishIndex >= 0 && normalize(v.options[product.finishIndex]) === normalize(this.finish));
      const row = node('div', null, 'collection-shopping__row');
      row.dataset.shoppingHandle = product.handle;
      const image = node('img'); image.loading = 'lazy'; image.width = 90; image.height = 90;
      const identity = node('div', null, 'collection-shopping__identity');
      const link = node('a', product.title); link.href = product.url; link.dataset.ihAction = 'product_open'; link.dataset.ihResource = product.handle;
      identity.append(link);
      row.append(image, identity);
      this.element.querySelector('[data-shopping-rows]').append(row);
      if (!matches.length) {
        image.hidden = true;
        row.append(node('p', 'This finish is not offered for this piece. Open the product to explore other finishes.', 'collection-shopping__unmatched'));
        return;
      }
      const sizeBox = node('div', null, 'collection-shopping__size');
      const size = node('select'); size.id = `ShoppingSize-${this.element.dataset.sectionId}-${index}`;
      size.dataset.ihAction = 'size_select'; size.dataset.ihResource = product.handle;
      const sizeLabel = node('label', 'Size / configuration'); sizeLabel.htmlFor = size.id;
      matches.forEach(v => {
        const option = node('option', v.options.map((value, i) => {
          const name = product.options[i];
          if (i === product.finishIndex) return '';
          if (/quantity|pack/i.test(name)) return new Set(matches.map(match => match.unit)).size > 1 ? (v.unit === 'pair' ? 'Pair (2 pieces)' : 'Single') : '';
          if (/center/i.test(name)) return `${value} centers`;
          if (/size|length/i.test(name)) return value;
          return `${name}: ${value}`;
        }).filter(Boolean).join(' · ') || v.title);
        option.value = v.id;
        if (!v.available) option.textContent += ' — unavailable';
        size.append(option);
      });
      const initial = matches.find(v => String(v.id) === String(selected?.id) && product.handle === this.element.dataset.currentHandle) || matches.find(v => v.available) || matches[0];
      size.value = initial.id;
      const status = node('small');
      sizeBox.append(sizeLabel, size, status);
      const quantityBox = node('div');
      const quantity = node('input'); quantity.type = 'number'; quantity.min = '0'; quantity.step = '1'; quantity.value = '0'; quantity.inputMode = 'numeric';
      quantity.id = `ShoppingQty-${this.element.dataset.sectionId}-${index}`;
      quantity.dataset.ihAction = 'quantity_select'; quantity.dataset.ihResource = product.handle;
      const quantityLabel = node('label', 'Quantity'); quantityLabel.htmlFor = quantity.id;
      quantityBox.append(quantityLabel, quantity);
      const total = node('div'); total.dataset.rowTotal = '';
      const detail = node('small'); const price = node('small');
      identity.append(detail, price);
      row.append(sizeBox, quantityBox, total);
      const entry = {product, matches, size, quantity, quantityLabel, link, image, detail, price, status, total};
      this.rows.push(entry);
      size.addEventListener('change', () => { quantity.value = '0'; this.changeRow(entry); this.totals(); });
      quantity.addEventListener('input', () => this.totals());
      this.changeRow(entry);
    }
    changeRow(row) {
      const v = row.matches.find(v => String(v.id) === row.size.value); row.variant = v;
      row.quantity.disabled = this.busy || !v.available;
      row.quantityLabel.textContent = v.unit === 'pair' ? 'Pairs' : 'Quantity';
      row.link.href = `${row.product.url}?variant=${v.id}`;
      row.image.hidden = !v.image;
      if (v.image) { row.image.src = v.image; row.image.alt = `${row.product.title} — ${v.options[row.product.finishIndex]}`; }
      row.detail.textContent = `SKU: ${v.sku} · ${v.unit === 'pair' ? 'Sold as a pair (2 pieces)' : 'Sold individually'}`;
      row.price.textContent = `${this.money(v.price)} / ${v.unit}`;
      if (row.product.handle === 'solid-brass-half-moon-cabinet-pulls') row.detail.textContent += ' · Order two for a circle.';
    }
    status(variant, quantity) {
      if (!variant.available) return 'Currently unavailable';
      if (!variant.held && window.InspireLeadTimes?.variants?.[String(variant.id)] === 5) return 'Longer lead time — estimated dispatch in 5 business days; transit is additional.';
      if (!variant.held && variant.tracked && variant.inventory > 0 && Date.parse(variant.stock?.valid_until) > Date.now() && variant.stock?.available >= Math.max(quantity, 1)) return 'Normally dispatches in 1–3 business days';
      if (variant.fulfillment?.status === 'special_order' && variant.fulfillment.approved === true) return `Special order — ${variant.fulfillment.lead_time || 'confirm lead time before ordering'}`;
      return 'Available to order — confirm quantity and dispatch timing';
    }
    totals() {
      let total = 0, count = 0, invalid = false;
      this.rows.forEach(row => {
        const qty = Number(row.quantity.value), v = row.variant;
        const valid = Number.isSafeInteger(qty) && qty >= 0 && (qty === 0 || (v.available && qty >= v.minimum && qty % v.increment === 0 && (v.maximum == null || qty <= v.maximum) && (v.limit == null || qty <= v.limit)));
        row.quantity.setCustomValidity(valid ? '' : 'Enter a whole quantity within the available quantity and ordering limits.');
        invalid ||= !valid;
        row.total.textContent = this.money(valid ? qty * v.price : 0);
        row.status.textContent = this.status(v, qty);
        if (valid) { total += qty * v.price; count += qty; }
      });
      this.element.querySelector('[data-shopping-total]').textContent = this.money(total);
      this.button.disabled = this.busy || invalid || !count;
    }
    async fresh() {
      const url = new URL(location.href);
      url.searchParams.set('section_id', this.element.dataset.sectionId);
      url.searchParams.set('_collection_check', Date.now());
      const response = await fetch(url, {cache:'no-store', credentials:'same-origin'});
      if (!response.ok) throw Error('We could not check current availability. Please try again.');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = read(doc.querySelector('[data-collection-data]'));
      if (!data?.products?.length || data.currency !== this.data.currency) throw Error('Your currency or collection has changed. Please refresh the page before adding these items.');
      return data;
    }
    async submit() {
      if (this.busy || !this.form.reportValidity()) return;
      const selected = this.rows.filter(row => Number(row.quantity.value) > 0).map(row => ({row, id:row.variant.id, quantity:Number(row.quantity.value), price:row.variant.price}));
      if (!selected.length) return;
      this.busy = true; this.totals(); this.button.textContent = 'Checking your selections…'; this.message.textContent = '';
      this.form.setAttribute('aria-busy', 'true');
      this.rows.forEach(row => { row.size.disabled = true; row.quantity.disabled = true; });
      let attemptedAdd = false;
      try {
        const fresh = await this.fresh();
        const cartResponse = await fetch(root() + 'cart.js', {cache:'no-store'});
        if (!cartResponse.ok) throw Error('We could not check your cart. Please try again.');
        const cart = await cartResponse.json();
        if (cart.currency !== fresh.currency) throw Error('Your cart currency changed. Please refresh this page.');
        const problems = [];
        selected.forEach(item => {
          const v = fresh.products.find(p => p.handle === item.row.product.handle)?.variants.find(v => v.id === item.id);
          const existing = cart.items.filter(line => line.variant_id === item.id).reduce((sum,line) => sum + line.quantity, 0);
          if (!v?.available) problems.push(`${item.row.product.title}: this selection is unavailable.`);
          else if ((v.limit != null && existing + item.quantity > v.limit) || (v.maximum != null && existing + item.quantity > v.maximum) || item.quantity < v.minimum || item.quantity % v.increment) problems.push(`${item.row.product.title}: the quantity is no longer available or exceeds its ordering limits. Please reduce the quantity or contact us.`);
          else if (v.price !== item.price) problems.push(`${item.row.product.title}: the price changed. Please review the updated subtotal and add again.`);
          if (v) { Object.assign(item.row.variant, v); this.changeRow(item.row); }
        });
        this.totals();
        if (problems.length) throw Error(problems.join(' '));
        if (this.current().finish !== this.finish) throw Error('The finish changed. Please review your matching selections before adding them.');
        this.button.textContent = 'Adding to cart…';
        attemptedAdd = true;
        const response = await fetch(root() + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', 'X-Requested-With':'XMLHttpRequest'}, body:JSON.stringify({items:selected.map(({id,quantity}) => ({id,quantity}))})});
        const result = await response.json();
        if (!response.ok || result.status) throw Error(typeof result.description === 'string' ? result.description : 'One or more selections could not be added.');
        const readback = await fetch(root() + 'cart.js', {cache:'no-store'});
        if (!readback.ok) throw Error('Your cart changed, but we could not confirm every item.');
        const after = await readback.json();
        for (const item of selected) {
          const beforeQty = cart.items.filter(v => v.variant_id === item.id).reduce((sum,v) => sum + v.quantity, 0);
          const afterQty = after.items.filter(v => v.variant_id === item.id).reduce((sum,v) => sum + v.quantity, 0);
          if (afterQty < beforeQty + item.quantity) throw Error('Your cart changed, but not every requested quantity was added.');
        }
        window.InspireEngagement?.track('collection-shopping', 'add_success', 'matching-collection');
        window.InspireEngagement?.flush();
        this.message.textContent = 'Your selections have been added. Opening your cart…';
        location.assign(root() + 'cart');
        return;
      } catch (error) {
        this.message.textContent = error.message + (attemptedAdd ? ' Please review your cart before trying again.' : '');
        if (attemptedAdd) { this.element.querySelector('[data-shopping-cart]').hidden = false; this.rows.forEach(row => { row.quantity.value = '0'; }); }
      } finally {
        this.busy = false; this.button.textContent = 'Add selected items to cart'; this.totals();
        this.form.removeAttribute('aria-busy');
        this.rows.forEach(row => { row.size.disabled = false; row.quantity.disabled = !row.variant.available; });
        // A finish selection may have changed while availability was being checked.
        this.update();
      }
    }
  }
  const init = () => document.querySelectorAll('[data-collection-shopping]').forEach(element => {
    if (!instances.has(element)) { instances.set(element, null); instances.set(element, new ShoppingList(element)); }
    const handles = read(element.querySelector('[data-collection-data]'))?.products?.map(product => product.handle) || [];
    document.querySelectorAll('[data-paired-products]').forEach(section => {
      const cards = [...section.querySelectorAll('.paired-products__grid > li')];
      cards.forEach(card => {
        const data = read(card.querySelector('[data-coordinate-variants]'));
        if (data && handles.includes(data.handle)) card.hidden = true;
      });
      if (cards.length && cards.every(card => card.hidden)) section.hidden = true;
      const heading = section.querySelector('h2');
      if (heading) heading.textContent = 'Other designs to consider';
      const subtitle = section.querySelector('header p');
      if (subtitle) subtitle.textContent = 'Alternative forms for a different look.';
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => instances.forEach(instance => instance?.update(data.variant)));
})();
